<template>
  <div class="center-wrap">
    <rh-header/>

    <div class="scroll-wrap">
      <div class="center-main">
        <div class="left">
          <div class="u-box">


            <div class="avatar-wrap">
              <img :src="avatarImg" class="avatar"/>
              <a class="setting" @click="goMyInfo('2')">
                <i class="fa fa-cog "></i>
              </a>
            </div>

            <div class="nickname">{{ newUserInfo.nickName }}</div>
<!--            <a class="my-data" @click="goMyInfo('1')">
              <i class="fa fa-file-text-o"></i>
              我的资料
            </a>-->
              <div class="already-real" v-if="newUserInfo.haveRealNameAuth">
                  已实名
              </div>

              <div v-else class="not-real">
                  未实名
                  <span @click="goReal">去认证</span>
              </div>

            <div class="member v0" v-if="newUserInfo.memberLevel == '1'">
              <img src="https://static.rhkj.com/renhe_fe/other/240.png"/>
              <span>试听学员</span>
            </div>

            <div class="member v1" v-if="newUserInfo.memberLevel == '2'">
              <img src="https://static.rhkj.com/renhe_fe/other/241.png"/>
              <span>正式学员</span>
            </div>

            <div class="member v2" v-if="newUserInfo.memberLevel == '3'">
              <img src="https://static.rhkj.com/renhe_fe/other/242.png"/>
              <span>VIP学员</span>
            </div>
          </div>


          <ul class="menus">
            <a v-for="(item,idx) in studentMenus.filter(f => !f.hidden)" :key="idx"
               class="item"
               :class="
             {
               'top20': item.marginTop,
               'active': item.routerName.includes(route.name),
             }"
               @click="goPage(item)"
              >
                <el-space>
                    <div>
                        <img
                            v-if="item.routerName.includes(route.name)"
                            :src="item.icon2" :class="item.iconClass"/>
                        <img
                            v-else
                            :src="item.icon1" :class="item.iconClass"/>
                    </div>
                    <span>{{ item.name }}</span>
                    <el-tag
                        v-if="item.tagNum"
                        type="danger"
                        size="small"
                        round
                        effect="dark"
                    >{{ item.tagNum }}</el-tag>
                </el-space>
            </a>
          </ul>
        </div>

        <div class="right">

          <div v-if="route?.meta?.pageBread" class="bread">
            <el-breadcrumb separator-icon="ArrowRight">
                <el-breadcrumb-item >首页</el-breadcrumb-item>
                <el-breadcrumb-item
                    v-for="(title,index) in route.meta.pageBread"
                    :key="index"
                >
                    {{ title }}
                </el-breadcrumb-item>
            </el-breadcrumb>
            <!-- <span>首页</span>
            <el-icon class="arrow">
              <ArrowRight/>
            </el-icon>
            <span>{{ route.meta.pageBread }}</span> -->
          </div>

          <router-view/>
        </div>
      </div>

      <div class="center-footer">
        <span>@2019-2026上海市杨浦区</span>
        <a href="http://beian.miit.gov.cn">10001002</a>
      </div>
    </div>
<!--     <swindleTip/>-->
      <job-demand-dialog
          v-model:visible="jobDemandVis"
      />

  </div>
</template>

<script setup>
import { useUserInfoStore } from '@/store/modules/userInfo.js'
import { examStatisticsApi } from '@/api/examCenter/exam'
import { getPreparatoryCourseListApi } from '@/api/new-student-study'
import RhHeader from '@/components/RhComponent/RhHeader'
import useUserStore from "@/store/modules/user";
import swindleTip from './comp/swindleTip.vue';
import JobDemandDialog from './JobDemandDialog.vue'
const userInfoStore = useUserInfoStore()
const userInfo = computed(() => {
  return useUserStore().userInfo
})

const preparatoryCourseList = ref([])
const getPreparatoryCourseList = async ()=>{
  try{
    const res = await getPreparatoryCourseListApi()
    if(res.data?.length){
        preparatoryCourseList.value = res.data
    }else{
        preparatoryCourseList.value = []
        studentMenus.value.splice(2,1)
    }
  }catch(err){
    console.log(err)
  }
}

const {userInfo:newUserInfo} = storeToRefs(userInfoStore)
onBeforeMount(async ()=>{
    getPreparatoryCourseList()
    const data = await userInfoStore.getUserInfo()
    /*if (data.includeEmploymentService == 1) { //“是否有就业服务”为“是”才会显示“我的就业”入口；
        const f = studentMenus.value.find(f => f.name == '我的就业')
        if (f) {
            f.hidden = false
        }
    }*/
    if (data.isPopUp == 1) {
        showJobDemand()
    }
})

const examStatistics = async ()=>{
    const typeList = ['101', '201', '301', '112','3333','111','601', '岗前测试']
    const res = await examStatisticsApi(typeList)
    if(res.data&&res.data.toBeCompletedCount){
        const index = studentMenus.value.findIndex(item => item.routerName.includes('MyExam'))
        studentMenus.value[index].tagNum = res.data.toBeCompletedCount
    }
}

const baseHost = inject('baseHost');
const avatarImg = computed(()=>{
    if(newUserInfo.value.avatar){
        return newUserInfo.value.avatar
    }
    return 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/default-avatar.png'
})

const studentMenus = ref([
  {
    name: '我的课表',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon2.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon2-2.png',
    link: `/studyCenter/stuSchedule`,
    routerName:['stuSchedule'],
    isNew:true
  },
  {
    name: '学习中心',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon1.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon1-1.png',
    link:   `/studyCenter/courseUser`,
    routerName:["courseUser-index","courseUser-my-course"],
    isNew:true
  },
  {
    name: '新生预科班',
    icon1: 'https://static.rhkj.com/renhe_fe/other/281.png',
    icon2: 'https://static.rhkj.com/renhe_fe/other/282.png',
    link:   `/studyCenter/newStudentStudy`,
    routerName:["NewStudentStudy","courseUser-my-course-v3"],
    isNew:true
  },
//   {
//     name: '学习中心-旧',
//     icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon1.png',
//     icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon1-1.png',
//     link:   `/studyCenter/courseUser-old`,
//     routerName:["courseUser-old"],
//     isNew:true
//   },
  // {
  //   name: '学员课表',
  //   icon1: 'https://static.rhkj.com/renhe_fe/other/281.png',
  //   icon2: 'https://static.rhkj.com/renhe_fe/other/282.png',
  //   iconClass: 'small',
  //   link: `${baseHost}/web/stuSchedule`,
  // },
/*  {
    name: '我的作业',
    icon1: 'https://static.rhkj.com/renhe_fe/other/284.png',
    icon2: 'https://static.rhkj.com/renhe_fe/other/285.png',
    link: `/learning/studyCenter/myHomework`,
    routerName: 'MyHomework', // 新项目里面的页面，带上routerName
  },*/
  /*  {
      name: '模考&练习',
      icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon2.png',
      icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon2-2.png',
      link: `/learning/studyCenter/myMockPractice`,
      routerName: 'MyMockPractice', // 新项目里面的页面，带上routerName
    },*/
  {
    name: '国考模拟&练习',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon5.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon5-5.png',
    link:   `/studyCenter/guokao-moni`,
    routerName:["guokao-moni"],
    isNew:true
  },
  // {
  //   name: '答题记录',
  //   icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon6.png',
  //   icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon6-6.png',
  //   link: `/studyCenter/answerRecord`,
  //   routerName:["answerRecord"],
  //   isNew:true
  // },
  // {
  //   name: '财税实训练习(用友)',
  //   icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon4.png',
  //   icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon4-4.png',
  //   link: `/studyCenter/cssc`,
  //   routerName: ['CSSC'], // 新项目里面的页面，带上routerName
  //   isNew:true
  // },
  // {
  //   name: '财税实训练习(仁和)',
  //   icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon4.png',
  //   icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon4-4.png',
  //   link: `/studyCenter/csscMain`,
  //   routerName: ['CsscMain'], // 新项目里面的页面，带上routerName
  //   isNew:true
  // },
  {
    name: '考试&作业',
    icon1: 'https://static.rhkj.com/renhe_fe/other/286.png',
    icon2: 'https://static.rhkj.com/renhe_fe/other/287.png',
    link: `/studyCenter/myExam`,
    routerName: ['MyExam'], // 新项目里面的页面，带上routerName
    isNew:true,
    tagNum:null,
  },
  {
    name: '错题记录',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon6.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon6-6.png',
    link: `/studyCenter/answerRecord`,
    routerName:["answerRecord"],
    isNew:true
  },
  {
    name: '训练营工具包',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj-old-jquery/ic_trainingCamp2.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj-old-jquery/ic_trainingCamp_active.png',
    link: `/studyCenter/trainingCamp`,
    routerName:['trainingCamp'],
    isNew:true
  },
    {
        name: '我的就业',
        icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon7.png',
        icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon7-7.png',
        link: `/studyCenter/myJob`,
        routerName:['MyJob'],
        isNew:true,
        hidden: false
    },
  {
    name: '答疑月刊',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj-old-jquery/ic_monthly.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj-old-jquery/ic_monthly_active.png',
    link: `/studyCenter/questionsMonthly`,
    routerName:['questionsMonthly'],
    isNew:true
  },
  /*{
    name: '问答',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon7.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon7-7.png',
    link: `/qa`,
    routerName:['qaMain'],
    isNew:true
  },*/
  {
    name: '结课证书',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon9.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon9-9.png',
    // link: `${baseHost}/web/uc/graduation/list`,
    link: `/studyCenter/certificate`,
    routerName: ['Certificate'],
    isNew: true
  },
  {
    name: '订单',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon10.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon10-10.png',
    link: `/studyCenter/myOrder`,
    routerName: 'MyOrder',
    isNew: true
  },
/*  {
    name: '协议',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon10.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon10-10.png',
    link: `${baseHost}/web/uc/order/user-agreements`,
    routerName:[]
  },*/
  // {
  //   name: '优惠券',
  //   icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon11.png',
  //   icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon11-11.png',
  //   link: `${baseHost}/web/uc/op/couponList`,
  //   routerName:[]
  // },
  /*{
    name: '资料',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon12.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon12-12.png',
    link: `/studyCenter/myInformation`,
    routerName:['myInformation'],
    marginTop: true,
    isNew:true
  },*/
  {
    name: '消息',
    icon1: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon13.png',
    icon2: 'https://static.rhkj.com/renhe_fe/fe-www-rhkj/images/studyCenter/icon13-13.png',
    link: `/studyCenter/messageCenter`,
    //marginTop: true,
    routerName: 'messageCenter',
    isNew: true

  },
])
const router = useRouter()
const goPage = (item)=>{
    if(Reflect.has(item,'isNew')&&item.isNew){
      router.push({
        path:item.link
      })
    }else{
      window.open(item.link)
    }
}
const goMyInfo = (tab)=>{
    router.push({
      name:"myInformation",
      query:{
        tab
      }
    })
}
const route = useRoute();
examStatistics()

function goReal() {
    router.push({
        name: 'RealNameAuth',
    })
}

const jobDemandVis = ref(false)

function showJobDemand() {
    jobDemandVis.value = true
}
</script>

<style scoped lang="scss">
.center-wrap {
  height: 100%;
  background-color: #e1e4eb;
  font-size: 14px;

  .scroll-wrap {
    height: calc(100% - 80px); // 减去的头部实际高度
    overflow-y: auto;

    .center-main {
      width: 1200px;
      margin: 35px auto 50px auto;
      display: flex;
      box-shadow: 0 0 18px rgba(47, 49, 54, 0.06);
      background-color: #fff;
      //align-items: stretch;

      .left {
        width: 200px;
        flex-shrink: 0;
        border-right: solid 4px #f0f0f3;

        $user-box-height: 264px;

        .u-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #f7fcff url("https://static.rhkj.com/renhe_fe/other/283.jpg") no-repeat 0 bottom;
          padding: 20px 10px;
          height: $user-box-height;
          box-sizing: border-box;

          .avatar-wrap {
            position: relative;

            .avatar {
              width: 72px;
              height: 72px;
              border-radius: 50%;
            }

            .setting {
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              width: 24px;
              height: 24px;
              border-radius: 50%;
              background: #fff;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              top: 52px;
              right: -2px;
              color: #7ebeff;
              font-size: 18px;
            }
          }


          .nickname {
            color: #333333;
            font-size: 14px;
            line-height: 30px;
            margin: 4px 0 0 0;
          }

            .already-real {
                margin-top: 10px;
                font-size: 12px;
                line-height: 16px;
                color: #50D2A4;
                border-radius: 31px;
                border: 1px solid #50D2A4;
                padding: 4px 10px;
            }

            .not-real {
                margin-top: 10px;
                font-size: 12px;
                line-height: 16px;
                color: #999999;
                border-radius: 31px;
                border: 1px solid #999999;
                padding: 4px 10px;
                > span {
                    color: #3498FF;
                    cursor: pointer;
                }
            }

          .my-data {
            padding-left: 10px;
            color: #30a4ff;
            font-size: 12px;
            line-height: 16px;
            margin-top: 8px;
            cursor: pointer;
          }

          .member {
            margin-top: 37px;
            margin-bottom: 0px;
            width: 132px;
            height: 34px;
            border-radius: 30px;
            display: flex;
            align-items: center;
            padding: 8px 20px;
            box-sizing: border-box;

            > img {
              width: 18px;
              height: 18px;
            }

            > span {
              margin-left: 10px;
              font-size: 16px;
              font-weight: 500;
            }

            &.v0 {
              background: linear-gradient(147deg, #F3F5F5 5%, #C9E5FF 91.47%);

              > span {
                color: #1580ED;
              }
            }

            &.v1 {
              background: linear-gradient(148deg, #FEE4B6 4.78%, #FDCD79 55.28%, #F8D48C 90.08%);

              > span {
                color: #9F5300;
              }
            }

            &.v2 {
              background: linear-gradient(148deg, #6B5942 4.78%, #312315 49.13%, #66553E 90.08%);

              > span {
                color: #FEE3BB;
              }
            }
          }
        }

        .menus {
          height: calc(100% - #{$user-box-height});
          box-sizing: border-box;
          padding-top: 21px;
          padding-bottom: 25px;
          background-color: #f7fcff;

          .item {
            line-height: 36px;
            display: flex;
            align-items: center;
            padding-left: 32px;
            border-left: 3px solid transparent;
            cursor: pointer;

            &.top20 {
              margin-top: 20px;
            }

            &.active {
              border-left-color: #30a4ff;
              background-color: #e2f2fe;

              > span {
                color: #30a4ff;
                font-weight: 700;
              }
            }

            img {
              width: 18px;
              height: 18px;
              display: block;

              &.small {
                width: 15px;
                height: 15px;
              }
            }

            > span {
              margin-left: 9px;
              font-size: 14px;
              color: #757b86;
            }

          }
        }
      }

      .right {
        width: 0;
        flex-grow: 1;
        // padding-left: 30px;
        // padding-top: 18px;
        // padding-right: 20px;
        padding: 16px;
        box-sizing: border-box;
        .bread {
          padding-top: 8px;
          margin-bottom: 10px;
          height: 48px;
          line-height: 48px;
          border-bottom: solid 1px #e1e3e9;
          color: #333333;

          .arrow {
            font-size: 10px;
            margin: 0 7px;
          }
        }
      }
    }

    .center-footer {
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;

      > span {
        color: #b9bcc5;
        font-size: 12px;
      }

      > a {
        color: #262626;
        font-size: 12px;

        &:hover {
          color: initial;
        }
      }
    }
  }
}
</style>
